import { ModalShell } from '@busy/ui';
import { useCutTimer } from '../../store/cutTimer';
import { useT } from '../../lib/i18n';
import { TodaysChair } from './TodaysChair';
import { PreCutCheckin } from './PreCutCheckin';
import { CutTypePicker } from './CutTypePicker';
import { BeforePhotoStep } from './BeforePhotoStep';
import { RatingStep } from './RatingStep';
import { AfterPhotoStep } from './AfterPhotoStep';
import { TransformationRevealStep } from './TransformationRevealStep';
import { LiveTimer } from './LiveTimer';
import { PostCutSummary } from './PostCutSummary';

// Cut Timer modal — orchestrates the full flow by routing on the store's `mode`.
// Canonical flow: chair → checkin → picker → running → summary.
//
// Closing the modal mid-cut just minimizes (cut keeps ticking via the persisted store).
// Closing the modal in summary discards the cut without saving.
export function CutTimer() {
  const mode = useCutTimer((s) => s.mode);
  const closeModal = useCutTimer((s) => s.closeModal);
  const t = useT();

  if (mode === 'idle') return null;

  // The live timer uses a dark variant; everything else uses the standard card variant.
  // Chair, checkin and picker have their own dark navy headers but the modal shell
  // stays card-light so the body content reads cleanly.
  const variant = mode === 'running' ? 'dark' : 'card';

  // Disable backdrop dismiss while running OR mid-post-cut — barbers
  // shouldn't be able to nuke an active cut (or one waiting on the
  // after-photo / reveal / summary) by tapping outside. They have to
  // use the X (which minimizes in those modes) or proceed via the CTAs.
  const dismissOnBackdrop =
    mode !== 'running' && mode !== 'rating' && mode !== 'after-photo' && mode !== 'reveal';

  return (
    <ModalShell
      open
      onClose={closeModal}
      variant={variant}
      size={mode === 'running' || mode === 'summary' || mode === 'chair' ? 'lg' : 'md'}
      dismissOnBackdrop={dismissOnBackdrop}
      ariaLabel={t('cut.modal.aria')}
    >
      {mode === 'chair' && <TodaysChair />}
      {mode === 'checkin' && <PreCutCheckin />}
      {mode === 'picker' && <CutTypePicker />}
      {mode === 'before-photo' && <BeforePhotoStep />}
      {mode === 'running' && <LiveTimer />}
      {mode === 'rating' && <RatingStep />}
      {mode === 'after-photo' && <AfterPhotoStep />}
      {mode === 'reveal' && <TransformationRevealStep />}
      {mode === 'summary' && <PostCutSummary />}
    </ModalShell>
  );
}
